import css from '@/src/home/presentation/views/home-page.view.css';

import ContactBlockView from '../../components/blocks/contact-block-view/contact-block-view';


export default function ContactPageView() {
  return (
    <div className={css.page}>
      <ContactBlockView titleTag="h1" />
    </div>
  );
}
